module.exports = __webpack_public_path__ + "static/img/文案策划-平面广告文案.fc7dfec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10008/文案策划-平面广告文案.png
// module id = jN7N
// module chunks = 1